module.exports = __webpack_public_path__ + "img/2_1.19333e6d.jpg";